const navMenuItems = [
    // {item: 'Home', navUrl: "/"},
    {item: 'About', navUrl: "/about"},
    // {item: 'Et Way', navUrl: "/etway"},
    {item: 'Trails', navUrl: "/trails"},
    {item: 'Blogs', navUrl: "/blogs"},  
    {item: 'Upcoming', navUrl: "/upcoming"},  
]

const aboutNavItems = [
    {item: 'Who are we?', navUrl: '/about/whoarewe'},
    {item: 'Our Target', navUrl: '/about/ourtarget'},
    {item: 'Our Mission', navUrl: '/about/ourmission'},
    {item: 'Our Journey', navUrl: '/about/ourjourney'},
    {item: 'Our Impact', navUrl: '/about/testimonials'},
    {item: 'Contact Us', navUrl: '/about/contactus'},
]

const blogDetailNavItems = [
    {item: 'Back to Blogs'}
]

export {
    navMenuItems,
    aboutNavItems,
    blogDetailNavItems,
}